var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { getUserData } from "../../../config/common";
import { Keynote, Breakout } from "./Breakouts";
var ISFModal = function (content) { return ({
    modalOverrides: {
        dismissHTML: "X",
        dismissStyle: {
            color: "#fff",
            fontSize: "25px"
        },
        style: {
            background: "#8f38de",
            color: "#fff",
            padding: "2em 3.5em",
            borderRadius: "10px"
        }
    },
    modal: content
}); };
var isOpened = function () { return new Date() > new Date("2022-11-15 08:00:00 UTC"); };
export var body = {
    userData: getUserData(),
    background: "https://assets.swoogo.com/uploads/full/2178452-636911ae3d2de.png",
    name: "On-Demand",
    links: [
        {
            width: "8.8%",
            height: "30.1%",
            left: "15.4%",
            top: "58.8%",
            label: "Look back at previous events",
            isExternal: false,
            href: "https://www.isflive.org/s/congress/back-in-time",
            target: "_blank"
        },
        __assign({ width: "12.8%", height: "36.1%", left: "3.4%", top: "34.8%", label: isOpened() ? "Keynote" : "Keynote - On demand presentations available from 15th November", isExternal: false }, (isOpened() ? { href: Keynote.location } : ISFModal(React.createElement("h1", null, "On demand presentations available from 15th November")))),
        __assign({ width: "12.8%", height: "36.1%", left: "83.9%", top: "34.8%", label: isOpened() ? "Breakout" : "Breakout - On demand presentations available from 15th November" }, (isOpened() ? { href: Breakout.location } : ISFModal(React.createElement("h1", null, "On demand presentations available from 15th November")))),
        {
            width: "8.2%",
            height: "14.7%",
            left: "45.9%",
            top: "81.6%",
            label: "Back to Atrium",
            href: "/Atrium"
        }
    ]
};
export var location = "/On-Demand";
